import { useRouter, useSearch } from "@tanstack/react-router";
import { type FragmentType, useFragment } from "@repo/graphql-types/fragment-masking";
import { graphql } from "@repo/graphql-types/gql";
import {
  TooltipDrawerRoot,
  TooltipDrawerTitle,
  TooltipDrawerBody,
} from "@/components/tooltip-drawer";

export const FollowUpAppointmentReminderMessageDrawerFragment = graphql(/* GraphQL */ `
  fragment FollowUpAppointmentReminderMessageDrawerFragment on agendamentos {
    nome
    Usuario {
      apelido
      nome
      sobrenome
    }
    UsuarioCompromisso {
      nome
    }
  }
`);

interface FollowUpAppointmentReminderMessageDrawerProps {
  data: FragmentType<typeof FollowUpAppointmentReminderMessageDrawerFragment> | undefined;
}

export const FollowUpAppointmentReminderMessageDrawer = ({
  data,
}: FollowUpAppointmentReminderMessageDrawerProps): JSX.Element => {
  const appointment = useFragment(FollowUpAppointmentReminderMessageDrawerFragment, data);

  const searchParams: Record<string, unknown> = useSearch({ strict: false });
  const router = useRouter();

  const isDrawerOpen = searchParams.action === "about";

  const setOpen = (isOpening: boolean): void => {
    if (!isOpening && isDrawerOpen) {
      router.history.back();
    }
  };

  const getUserNickname = (): string => {
    if (appointment?.Usuario?.apelido) {
      return appointment.Usuario.apelido;
    }

    const name = appointment?.Usuario?.nome ?? "";
    const lastName = appointment?.Usuario?.sobrenome ?? "";

    return `${name} ${lastName}`;
  };

  return (
    <TooltipDrawerRoot
      open={isDrawerOpen}
      setOpen={(isOpening) => {
        setOpen(isOpening);
      }}
    >
      <TooltipDrawerTitle>Modelo da mensagem</TooltipDrawerTitle>
      <TooltipDrawerBody>
        <div className="mt-2 flex flex-col gap-2">
          <p>Olá, {appointment?.nome}.</p>
          <p>
            {getUserNickname()} gostaria de te lembrar que está na hora de agendar seu
            próximo atendimento.
          </p>
          <p>
            Selecione a opção: {appointment?.UsuarioCompromisso?.nome} e confira os
            horários disponíveis.
          </p>
          <p>Estamos esperando por você.</p>
        </div>
      </TooltipDrawerBody>
    </TooltipDrawerRoot>
  );
};
